import { customAlphabet } from 'nanoid';

export const generatePassword = (number = 10) => {
    const nanoid = customAlphabet('0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ', number);
    return nanoid(number);
}

